
<script>
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'
import SearchControls from '@/components/services/ui/searchControls.vue'
import FavoritesFilters from './view/Filters.vue'

import {
  FavoritesCards,
  FavoritesTable
} from './ui'

export default {
  name: 'favorites',
  components: {
    infiniteScroll,
    SearchControls,
    FavoritesFilters,
    FavoritesCards,
    FavoritesTable,
  },
  metaInfo: {
    title: 'Избранное'
  },
  computed: {
    isLoading() {
      return this.$store.getters['favorites/isLoading']
    },
    isLoadingMore() {
      return this.$store.getters['favorites/isLoadingMore']
    },
    isFiltering() {
      return this.$store.getters['favorites/isFiltering']
    },
    isFiltersApplied() {
      return this.$store.getters['favorites/isFiltersApplied']
    },
    collection() {
      return this.$store.getters['favorites/getCollection']
    },
    pagination() {
      return this.$store.getters['favorites/getPagination']
    },
    getFields() {
      return this.$store.getters['favorites/getFields']
    },
    viewType() {
      return this.$store.getters['favorites/getViewType']
    },
    emptyFilteringResults() {
      return this.$store.getters['favorites/isEmptyFilteringResults']
    },
    isCollectionEmpty() {
      return !this.isLoading
        && !this.isFiltering
        && !this.isLoadingMore
        && this.collection.length === 0
    },
  },
  created() {
    this.$store.dispatch('favorites/getCollection', {
      ...this.getFields
    })

    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'currencies',
        target: 'favorites.dictionaries.currencies'
      }
    })
  },
  beforeDestroy() {
    this.$store.commit('favorites/setInitialState')
  },
  methods: {
    loadMore() {
      this.$store.commit('favorites/updateIsLoadingMore', true)

      this.$store.dispatch('favorites/getCollection', {
        ...this.getFields,
        page: this.pagination.page + 1
      })
    },
    filtering() {
      this.$store.commit('favorites/updateIsFiltersApplied', true)

      this.$store.dispatch('favorites/filterCollection', {
        ...this.getFields
      })
    },
    sort() {
      this.$store.commit('favorites/updateIsLoadingMore', true)
      this.$store.commit('favorites/setCollection', [])

      this.$store.dispatch('favorites/getCollection', {
        ...this.getFields
      })
    }
  }
}
</script>

<template>
  <div>
    <h1 class="search-content__title">
      Избранное
    </h1>
    <div class="search-content">
      <div class="search-content__results">
        <search-controls
          v-if="!isLoading"
          store-module="favorites"
          getter-fields-name="getFields"
          getter-field-name="getField"
          setter-field-name="updateField"
          @sort="sort"
        />
        <infinite-scroll
          v-if="collection.length || isLoading || isLoadingMore"
          :pagination="pagination"
          :is-loading="isLoading || isFiltering || isLoadingMore"
          :is-loading-blocked="!isFiltersApplied"
          @loadMore="loadMore"
          @filtering="filtering"
        >
          <template>
            <favorites-cards
              v-if="viewType === 'card'"
              :collection="collection"
            />
            <favorites-table
              v-if="viewType === 'table'"
              :collection="collection"
            />
          </template>
        </infinite-scroll>
        <div
          v-if="!isLoading || !isFiltering || !isLoadingMore"
          class="search-content__no-results"
        >
          <template v-if="isCollectionEmpty">
            <h2 v-if="emptyFilteringResults">
              Ничего не найдено<br>
              Попробуйте сделать фильтры менее строгими.
            </h2>
            <h2 v-else>
              Ничего не найдено
            </h2>
          </template>
          <h2 v-if="errors.searchFailed">
            Ошибка поиска<br>
            Кажется что-то пошло не так
          </h2>
        </div>
      </div>
      <favorites-filters />
    </div>
  </div>
</template>
